import 'css-chunksrc/client/scenes/projectResourceEdition/styles.scss';export default {
  "body": "_body_2rzv2_1",
  "footer": "_footer_2rzv2_8"
};